import React from "react";
import { useAppDispatch, useAppSelector } from "../../../App/hooks";
import UsersDropdown from "../../../Components/Dropdown/Users/UsersDropdown";
import {
  addEditDeltaHedgeAccountFormValuesChangeHandler,
  setAddEditDeltaHedgeAccountsFormValues,
  setDeltaHedgeAccountFlag,
  setHeltaHedgeAccountsAddEditModalFlag,
} from "../../../Features/DeltaHedgeAccounts/deltaHedgeAccountsSlice";
import { addDeltaHedgeAccount } from "../../../Requests/deltaHedgeAccounts";
import Button from "../../../Components/Button";
import { toast } from "react-toastify";
import { packetErrorHandler } from "../../../Utils/requestUtils";
import { IAddDeltaHedgeAccount } from "../../../Interfaces/deltaHedgeAccounts";
// Common Components
import { DynamicDropdown, StaticDropdown } from "src/Components";
// Services
import {
  getStrategies,
  editAccount,
  getProfiles,
} from "src/Requests/deltaHedgeAccounts";
import { getUsers } from "src/Requests/connections";
// Types
import { DropdownItem } from "src/Interfaces/dropdownInterfaces";
import { SelectionType } from "src/Interfaces/deltaHedgeAccounts";

const AddEditForm = () => {
  const formValues = useAppSelector(
    (store) => store.deltaHedgeAccountsSlice.addEditFormValues
  );

  const dispatch = useAppDispatch();

  const onChange = (name: string, value: any) => {
    dispatch(addEditDeltaHedgeAccountFormValuesChangeHandler({ name, value }));
  };

  React.useEffect(() => {
    if (formValues?.isManual === true) {
      dispatch(
        setAddEditDeltaHedgeAccountsFormValues({
          ...formValues,
          selectionType: SelectionType.Manual,
        })
      );
    }
    if (formValues?.isManual === false) {
      dispatch(
        setAddEditDeltaHedgeAccountsFormValues({
          ...formValues,
          selectionType: SelectionType.Calculational,
        })
      );
    }
  }, [formValues?.isManual]);

  const dto = React.useMemo(() => {
    const data: IAddDeltaHedgeAccount = {} as IAddDeltaHedgeAccount;
    if (formValues?.deltahedgeAccountId) {
      data.deltahedgeAccountId = formValues?.deltahedgeAccountId;
    }
    if (formValues?.accountId) {
      data.accountId = formValues?.accountId;
    }
    if (formValues?.strategyId) {
      data.strategyId = Number(formValues?.strategyId);
    }
    if (formValues?.backtestProfileId) {
      data.backtestProfileId = Number(formValues?.backtestProfileId);
    }
    if (formValues?.selectionType) {
      data.isManual =
        formValues?.selectionType === SelectionType.Manual ? true : false;
    }
    return data;
  }, [formValues]);

  const selectionOptions: DropdownItem[] = [
    { id: SelectionType.Manual, name: "دستی" },
    { id: SelectionType.Calculational, name: "محاسباتی" },
  ];

  const properFunction = () =>
    formValues?.deltahedgeAccountId
      ? editAccount(dto)
      : addDeltaHedgeAccount(dto);

  const addEditHandler = () => {
    properFunction()
      .then((resp) => {
        if (resp.data) {
          toast.success(resp.msg);
          dispatch(setDeltaHedgeAccountFlag(true));
          dispatch(setHeltaHedgeAccountsAddEditModalFlag(false));
          dispatch(
            setAddEditDeltaHedgeAccountsFormValues({} as IAddDeltaHedgeAccount)
          );
        } else toast.error(resp.msg);
      })
      .catch(packetErrorHandler);
  };

  const checkBtnDisabled = () => {
    if (!formValues.accountId) return true;

    return false;
  };

  return (
    <div className="flex flex-col justify-start items-start mx-auto gap-3">
      <DynamicDropdown
        dropdown={{
          name: "accountId",
          placeholder: "اکانت",
          extraLabel: true,
        }}
        value={String(formValues.accountId)}
        getData={() => getUsers()}
        onChange={onChange}
      />
      <DynamicDropdown
        dropdown={{
          name: "strategyId",
          placeholder: "استراتژی",
          extraLabel: true,
        }}
        getData={getStrategies}
        onChange={onChange}
        value={String(formValues?.strategyId)}
      />
      <DynamicDropdown
        dropdown={{
          name: "backtestProfileId",
          placeholder: "پروفایل",
          extraLabel: true,
        }}
        getData={getProfiles}
        onChange={onChange}
        value={String(formValues?.backtestProfileId)}
      />

      <StaticDropdown
        dropdown={{
          name: "selectionType",
          placeholder: "روش انتخاب",
          extraLabel: true,
        }}
        options={selectionOptions}
        onChange={onChange}
        value={formValues?.selectionType}
      />
      <Button
        text={"ثبت"}
        variant="contained"
        onClick={addEditHandler}
        disabled={checkBtnDisabled()}
      />
    </div>
  );
};

export default AddEditForm;
